import ExampleImage2 from './images/chipcommunity.jpg';
import ExampleImage3 from './images/mrcommunity.jpg';
import './Home.css';
import SectionHeader from './components/SectionHeader.js'
import Button from './components/Button.js';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function Home() {
  return (
    <div class="homeview">
      <div class="topsection">
        <div class="topsectioncontent">
          <h1 class="title">Music Server Charts</h1>
          <h2 class="subtitle">Bring your server together with its own playlist!</h2>

          <a href="/dashboard/get-started">
            <Button primary big>Get started</Button>
          </a>
        </div>
      </div>

      <SectionHeader>Featured playlists:</SectionHeader>

      <div class="regularsection">
        <div class="sectioncontainer">
          <a href="https://open.spotify.com/playlist/5XTqiba489JJ6vmjpafzFC">
            <img class="albumart" src={ExampleImage3} width="300px" height="300px" />
          </a>
          <a href="https://open.spotify.com/playlist/3GhfE12AWv2Z51tstFkJk7">
            <img class="albumart" src={ExampleImage2} width="300px" height="300px" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;
